<payee-dropdown
  width="max"
  [options]="langs"
  [formControl]="languageControl"
  [color]="color"
  [isBorderButton]="isBorderButton"
  [isRoundButton]="false"
>
  <ng-template
    #menuDisplayTemplate
    let-menuOpen="menuOpen"
  >
    <div class="lang-menu-button flex vcenter">
      <img
        class="lang-flag-circle"
        [src]="getFlagUrl(selectedLanguage)"
        [alt]="langLabels[selectedLanguage]"
      />
    </div>
  </ng-template>

  <ng-template
    #itemDisplayTemplate
    let-option
  >
    <div class="lang-item flex vcenter">
      <img
        class="lang-flag-circle"
        [src]="getFlagUrl(option)"
        [alt]="langLabels[option]"
      />
      <span>{{ langLabels[option] }}</span>
    </div>
  </ng-template>
</payee-dropdown>
